import { AUTH_COOKIE_DOMAIN, AUTH_OAUTH_DOMAIN, AUTH_REDIRECT_SIGN_IN, AUTH_REDIRECT_SIGN_OUT, AUTH_REGION, AUTH_USER_POOL_ID, AUTH_USER_POOL_WEB_CLIENT_ID } from "./envConfig";

export const AwsConfigAuth = {
  Auth: {
    region: AUTH_REGION,
    userPoolId: AUTH_USER_POOL_ID,
    userPoolWebClientId: AUTH_USER_POOL_WEB_CLIENT_ID, //App Client ID
    mandatorySignIn: false,
    cookieStorage: {
      domain: AUTH_COOKIE_DOMAIN,
      path: "/",
      expires: 365,
      sameSite: "strict",
      secure: false,
    },
    authenticationFlowType: "USER_SRP_AUTH",
    oauth: {
      domain: AUTH_OAUTH_DOMAIN,
      scope: [
        "phone",
        "email",
        "profile",
        "openid",
        "aws.cognito.signin.user.admin",
      ],
      redirectSignIn: AUTH_REDIRECT_SIGN_IN,
      redirectSignOut: AUTH_REDIRECT_SIGN_OUT,
      responseType: "token", // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
  },
};